const getPreloadedFonts = (cdnUrl) => [
    {
        url: `${cdnUrl}/shared/static/fonts/open-sans/opensans-light.woff2`,
        type: `font/woff2`,
    },
    {
        url: `${cdnUrl}/shared/static/fonts/open-sans/opensans-light.woff`,
        type: `font/woff`,
    },
    {
        url: `${cdnUrl}/shared/static/fonts/open-sans/opensans-regular.woff2`,
        type: `font/woff2`,
    },
    {
        url: `${cdnUrl}/shared/static/fonts/open-sans/opensans-regular.woff`,
        type: `font/woff`,
    },
    {
        url: `${cdnUrl}/shared/static/fonts/open-sans/opensans-semibold.woff2`,
        type: `font/woff2`,
    },
    {
        url: `${cdnUrl}/shared/static/fonts/open-sans/opensans-semibold.woff`,
        type: `font/woff`,
    },
    {
        url: `${cdnUrl}/shared/static/fonts/open-sans/opensans-bold.woff2`,
        type: `font/woff2`,
    },
    {
        url: `${cdnUrl}/shared/static/fonts/open-sans/opensans-bold.woff`,
        type: `font/woff`,
    },
    {
        url: `${cdnUrl}/shared/static/fonts/aeroport/Aeroport-bold.woff2`,
        type: `font/woff2`,
    },
    {
        url: `${cdnUrl}/shared/static/fonts/aeroport/Aeroport-bold.woff`,
        type: `font/woff`,
    },
];

export { getPreloadedFonts };
//# sourceMappingURL=helpers.js.map
